var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_vm._v(" "+_vm._s(_vm.item.text)+" ")]),_c('v-flex',{staticClass:"text-right"},[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_c('v-icon',[_vm._v("$info")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.langPath + _vm.item.value)))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }